import jsPDF from 'jspdf';
import 'jspdf-autotable';
import React, { useEffect, useRef, useState } from 'react';
import { Card, Col, Row, Table } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import { NetPositonService } from "../../services/NetPositionService";
import NumberFormatter from "../components/NumberFormatter";
import '../custom.css';
import { useLocation } from "react-router-dom";
import html2canvas from "html2canvas";

function Netposition() {

    const pdfRef = useRef();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [netsummary, setNetsummary] = useState([]);
    const [date, setDate] = useState([]);
    const [total, setTotal] = useState([]);
    const [buytotal, setBuytotal] = useState([]);
    const [selltotal, setSelltotal] = useState([]);
    const [week, setWeek] = useState([]);
    const tableRef = useRef();
    const { userId, adminId, valan, userName } = location.state || {};

    useEffect(() => {
        setLoading(true);
        NetPositonService.getCustomerNetpisition(userId ? {'userId': userId, valan: valan} : {adminId: adminId, valan: valan}).then(res => {
            setLoading(false);
            if (res.code === 1) {
                if (res.data.summaryNetPosition.summary.length > 0) {
                    setNetsummary(res.data.summaryNetPosition.summary);
                }
                setDate(res.data.summaryNetPosition.summary[0].valanDate);
                setTotal(res.data.summaryNetPosition.grandTotal);
                setBuytotal(res.data.summaryNetPosition.buyAverageTotal);
                setSelltotal(res.data.summaryNetPosition.sellAverageTotal);
                setWeek(res.data.summaryNetPosition.summary[0].currentWeek);
            }
        });
    }, [userId]);

    const exportToPDF = () => {
        const input = pdfRef.current;
        html2canvas(input, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");
            const imgWidth = 210; // A4 width in mm
            const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio
            const paddingTop = 20; // Space after the title
            pdf.setFontSize(12); // Set title font size
            pdf.text(process.env.REACT_APP_NAME, 105, 15, { align: "center" }); // Centered title
    
            pdf.addImage(imgData, "PNG", 0, paddingTop, imgWidth, imgHeight);
            pdf.save("netposition.pdf");
        });
    };

    const handlePrint = () => {
        const printContent = document.getElementById("printArea");
        const originalTitle = document.title;
        document.title = "netposition.pdf"; // Set the desired filenam
        const originalContent = document.body.innerHTML;
        
        document.body.innerHTML = printContent.innerHTML;;
        window.print();
        document.title = originalTitle;
        document.body.innerHTML = originalContent;
        window.location.reload(); // Reload the page to restore UI
      };


    return (
        <Card className='mb-5 white-row white-back zoom'>
            <Card.Body className='pe-0 mb-4'>
                <Row>
                    <Col className="text-end">
                        <Button variant="success" onClick={handlePrint} style={{ width: 80 }}>SAVE</Button>
                    </Col>
                </Row>
                {loading ? (
                    <div className="container vh-100">
                        <div className="d-flex align-items-center justify-content-center h-90">
                            <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div ref={pdfRef} id="printArea" style={{ marginTop: "10px"}}>
                       {userName ?  
                     <Row>
                        <Col xl={12} sm={12} xs={12} className='text-center fss-09'>
                            <label>{userName} </label> 
                        </Col>    
                    </Row> : ""  }
                    <Table ref={tableRef} bordered className="mt-1" responsive>
                        <thead >
                            <tr>
                                <th className=" white-back fss-14 pt-1 pb-1 printFontFamily">Customer Net Position</th>
                                <th className="text-center white-back fss-14 pt-1 pb-1 printFontFamily" >{week}</th>
                                <th colSpan={2}  className="text-end white-back fss-14 pt-1 pb-1 printFontFamily">{date}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {netsummary.map((ns, index) => (
                                <tr key={index}>
                                    <td colSpan={12}>
                                        <Table bordered responsive>
                                            <thead className=" bg-thead">
                                                <tr>
                                                    <th colSpan={12} className="text-center pt-1 pb-1 fss-14 printFont">{ns.userName}</th>
                                                </tr>
                                            </thead>
                                            <thead className="netposition-header">
                                                <tr >
                                                    <th className="fss-14 printFont">Script Name</th>
                                                    <th className="text-end fss-14 pt-1 pb-1 printFont">Buy Qty</th>
                                                    <th className="text-end fss-14 pt-1 pb-1 printFont">Buy Avg.</th>
                                                    <th className="text-end fss-14 pt-1 pb-1 printFont">Sell Qty</th>
                                                    <th className="text-end fss-14 pt-1 pb-1 printFont">Sell Avg.</th>
                                                    <th className="text-end fss-14 pt-1 pb-1 printFont">Pos Qty</th>
                                                    <th className="text-end fss-14 pt-1 pb-1 printFont">LIVE</th>
                                                    <th className="text-end fss-14 pt-1 pb-1 printFont">M2M</th>
                                                </tr>
                                            </thead>
                                            <tbody className="fss-14">
                                                {ns.summaryList.map((item, idx) => (
                                                    <tr key={idx}>
                                                        <td className="text-black">{item.scriptName}</td>
                                                        <td className="text-end text-black">{item.buyQty}</td>
                                                        <td className="text-end text-black"> <NumberFormatter number={item.buyAverageRate}></NumberFormatter></td>
                                                        <td className="text-end text-black">{item.sellQty}</td>
                                                        <td className="text-end text-black"><NumberFormatter number={item.sellAverageRate}></NumberFormatter></td>
                                                        <td className="text-end text-black">{item.netQty}</td>
                                                        <td className="text-end text-black">{item.ltp}</td>
                                                        <td className="text-end text-black"> <NumberFormatter number={item.totalMtm}></NumberFormatter></td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot>
                                                <tr className="gray-row">
                                                    <td style={{borderRight: "0px"}}><b></b></td>
                                                    <td className='text-end fss-14 pt-1 pb-1 removeborder' >{ns.totalBuyQty}</td>
                                                    <td className='text-end fss-14 pt-1 pb-1 removeborder' ></td>
                                                    <td className='text-end fss-14 pt-1 pb-1 removeborder' >{ns.totalSellQty}</td>
                                                    <td className='text-end fss-14 pt-1 pb-1 removeborder' ></td>
                                                    <td className='text-end fss-14 pt-1 pb-1 removeborder' >{ns.totalNetQty}</td>
                                                    <td className='text-end fss-14 pt-1 pb-1 removeborder' ></td>
                                                    <td className='text-end fss-14 pt-1 pb-1' style={{borderLeft: "0px"}} ><NumberFormatter number={ns.grandTotal}></NumberFormatter></td>
                                                </tr>
                                            </tfoot>
                                        </Table>
                                    </td>
                                </tr>
                            ))}

                            <tr className='fss-14'>
                                <td colSpan={4} className="text-center amount"><div className="d-flex justify-content-center fss-1 text-black" >Grand Total: &nbsp;<NumberFormatter number={total}></NumberFormatter></div></td>
                            </tr>
                            <tr className='fss-14'>
                                <td colSpan={2} className="text-center "><div className="d-flex justify-content-center fss-1 text-black">Buy Turnover: &nbsp;<NumberFormatter number={buytotal}></NumberFormatter></div></td>
                                <td className="text-center"><div className="d-flex justify-content-center fss-1 text-black">Sell Turnover: &nbsp;<NumberFormatter number={selltotal}></NumberFormatter></div></td>
                            </tr>

                        </tbody>
                           
                    </Table></div>
                )}
            </Card.Body>
        </Card>
    );
}

export default Netposition;